// extracted by mini-css-extract-plugin
module.exports = {"investors":"investors_investors__3Y06o","nameBlock":"investors_nameBlock__A3GF_","investor":"investors_investor__yq3vY","investorsGrid":"investors_investorsGrid__iiM_9"};